const CertifyIcon = ({ size = 24, ...props }: { size?: number }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 ${size} ${size}`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13 7.99981L8.99995 11.9998L6.99995 9.99981M11.246 1.45879L12.467 2.49929C12.7746 2.76143 13.1566 2.91991 13.5594 2.95206L15.1585 3.0795C16.0986 3.15452 16.8453 3.9008 16.9204 4.84093L17.0475 6.44024C17.0797 6.8431 17.2387 7.22559 17.5008 7.53319L18.5409 8.75382C19.1526 9.47164 19.1527 10.5275 18.541 11.2454L17.5009 12.4662C17.2388 12.7738 17.08 13.1564 17.0478 13.5593L16.9199 15.1583C16.8449 16.0984 16.0993 16.8452 15.1591 16.9202L13.5595 17.0478C13.1567 17.08 12.7744 17.2381 12.4667 17.5002L11.246 18.5407C10.5282 19.1525 9.47168 19.1526 8.75386 18.5409L7.53316 17.5003C7.22555 17.2382 6.84325 17.0798 6.44038 17.0477L4.84077 16.9202C3.90064 16.8452 3.15505 16.0986 3.08003 15.1585L2.9521 13.5594C2.91995 13.1565 2.76111 12.7742 2.49898 12.4666L1.45894 11.2454C0.847212 10.5276 0.846926 9.47203 1.45865 8.7542L2.49963 7.53301C2.76176 7.22541 2.91908 6.84311 2.95122 6.44024L3.07915 4.84112C3.15417 3.90099 3.90192 3.15442 4.84205 3.0794L6.43989 2.95196C6.84276 2.91981 7.22525 2.76146 7.53285 2.49932L8.75396 1.45879C9.47178 0.847069 10.5282 0.847069 11.246 1.45879Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default CertifyIcon
